<ngb-toast *ngFor="let toast of toastService.toasts" [class]="toast.classname" [autohide]="true"
  [delay]="toast.delay || 25000" (hidden)="toastService.remove(toast)" class="toast">
  <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
    <ng-template [ngTemplateOutlet]="toast.textOrTempl">
      <div class="span">{{toast.title}}</div>
      <div class="span">{{toast.message}}</div>
    </ng-template>
  </ng-template>

  <ng-template #text>
    <!-- {{ toast.textOrTempl }} -->
    <div class="row align-middle px-5">
      <div class="col-1 pl-0 my-auto">
        <i [ngClass]="toast.iconClass"></i>
      </div>
      <div class="col-11">
        <div class="d-inline-block pl-2">
          <span>{{toast.title}}</span><br>
          <p class="mb-0">{{ (toast.message.length>360)?(toast.message | slice:0:360)+'...':(toast.message) }}</p>
        </div>
      </div>
    </div>


  </ng-template>
</ngb-toast>